export type CountryCode = 'au' | 'us';

export interface CountryConfig {
  code: CountryCode;
  name: string;
  demonym: string;
  lang: string;
  locale: string;
  currency: string;
  currencySymbol: string;
  domain: string;
  retailerCount: string;
  shopCount: string;
  productCount: string;
}

export const COUNTRIES: Record<CountryCode, CountryConfig> = {
  au: {
    code: 'au',
    name: 'Australia',
    demonym: 'Australian',
    lang: 'en-AU',
    locale: 'en_AU',
    currency: 'AUD',
    currencySymbol: '$',
    domain: 'buywisely.com.au',
    retailerCount: '20,000+',
    shopCount: '10,000+',
    productCount: '2.9 million+',
  },
  us: {
    code: 'us',
    name: 'United States',
    demonym: 'American',
    lang: 'en-US',
    locale: 'en_US',
    currency: 'USD',
    currencySymbol: '$',
    domain: 'buywisely.io',
    retailerCount: '5,000+',
    shopCount: '5,000+',
    productCount: '1 million+',
  },
};

export const SUPPORTED_COUNTRIES: CountryCode[] = ['au', 'us'];
export const DEFAULT_COUNTRY: CountryCode = 'us';

export function isValidCountry(code: string): code is CountryCode {
  return SUPPORTED_COUNTRIES.includes(code as CountryCode);
}

export function getCountryFromEnv(): CountryCode {
  const code = process.env.COUNTRY_CODE?.toLowerCase();
  if (code && isValidCountry(code)) {
    return code;
  }
  return 'au';
}

export const POPULAR_RETAILERS: Record<CountryCode, string[]> = {
  au: [
    'JB Hi-Fi',
    'Harvey Norman',
    'The Good Guys',
    'Amazon Australia',
    'Kogan',
    'Officeworks',
    'Bunnings',
    'Big W',
  ],
  us: [
    'Best Buy',
    'Amazon',
    'Walmart',
    'Target',
    'Home Depot',
    'Costco',
    'Newegg',
    "Lowe's",
  ],
};
